import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { ClientProfile } from "@/types";

interface AppState {
  // Phase 1: selected account from the selector page
  accountId: string | null;
  accountName: string | null;
  profile: ClientProfile | null;

  // Actions
  selectAccount: (id: string, name: string) => void;
  setProfile: (profile: ClientProfile) => void;
  logout: () => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      accountId: null,
      accountName: null,
      profile: null,

      selectAccount: (id, name) =>
        set({ accountId: id, accountName: name, profile: null }),

      setProfile: (profile) => set({ profile }),

      logout: () =>
        set({ accountId: null, accountName: null, profile: null }),
    }),
    {
      name: "millbank-session",
      partialize: (state) => ({
        accountId: state.accountId,
        accountName: state.accountName,
      }),
    }
  )
);
